import { translate } from "../core/i18n";
import { showQuestionModal, hideModal } from "../components/modals/QuestionModal";
import { deleteProject } from "../core/code/saver";
import { getRedirectUrl, redirectTo } from "../features/redirect";
import { getDomainCfg } from "../core/state";

interface UseDeleteProjectOptions {
  projectId?: string;
  projectName?: string;
  onDeleted?: () => void;
}

export const useDeleteProject = (options: UseDeleteProjectOptions = {}) => {
  const { projectId, projectName, onDeleted } = options;

  const requestDeleteProject = () => {
    const opts = {
      okTitle: translate("delete-project-modal-ok"),
      okColor: "btn-danger",
      cancelTitle: translate("modal-cancel"),
      cancelColor: "btn-secondary"
    };
    
    const projectDisplayName = projectName ? `"${decodeURIComponent(projectName)}"` : "";
    const message = projectName 
      ? translate("delete-project-modal-message") + " " + projectDisplayName + "?"
      : translate("delete-project-modal-message");
    
    showQuestionModal(
      translate("delete-project-modal-title"),
      message,
      deleteProjectAccepted,
      deleteProjectDeclined,
      opts
    );
  };

  const deleteProjectDeclined = () => hideModal();

  const deleteProjectAccepted = async () => {
    hideModal();
    await deleteProject(projectId);
    
    // Call custom callback if provided, otherwise redirect to project list
    if (onDeleted) {
      onDeleted();
    } else {
      redirectTo(getRedirectUrl(getDomainCfg().viewSettings.projectsView));
    }
  };

  return { requestDeleteProject };
};

